export default (text) => {
  let output_html = '';
  let counter;

  if (text && text.length > 0) {
    output_html += '';
    for (counter = 0; counter < text.length; counter++) {
      switch (text[counter]) {
        case '\n':

          if (text[counter + 1] === '\n') {
            output_html += '</p>\n<p>';
            counter++;
          } else output_html += '<br>';

          break;

        case ' ':
          if (text[counter - 1] !== ' ' && text[counter - 1] !== '\t') output_html += ' ';
          break;

        case '\t':
          if (text[counter - 1] !== '\t') output_html += ' ';
          break;

        case '&':
          output_html += '&amp;';
          break;

        case '"':
          output_html += '&quot;';
          break;

        case '>':
          output_html += '&gt;';
          break;

        case '<':
          output_html += '&lt;';
          break;

        default:
          output_html += text[counter];
      }
    }
  }

  return output_html;
};
